import * as Focus from '../common/focus';

(function ($) {
  let slideBarOpen = null;

  function closeSlidebarMenu() {
    slideBarOpen.attr('aria-expanded', false);
    $('body').removeClass('mobile-menu-open');
    Focus.untrapFocusInside($('#mobile-menu'));
    $(document).off('click.close_slidebar').off('keyup.close_slidebar');
    $('.nav-desktop .dropdown.opened').removeClass('opened');
  }

  function tryClosingSlidebarMenu(event) {
    // Keyboard
    if ('undefined' !== typeof event.keyCode) {
      // ESCAPE
      if (27 === event.keyCode) {
        $('.vtx-burger-container').focus();
        closeSlidebarMenu();
      }
    }
    // Click
    else if (!$(event.target).closest('#mobile-menu-wrapper').length) {
      closeSlidebarMenu();
    }
  }

  function openSlidebarMenu() {
    slideBarOpen.attr('aria-expanded', true);
    $('body').addClass('mobile-menu-open');
    Focus.trapFocusInside($('#mobile-menu'));
    $(document)
      .on('click.close_slidebar', tryClosingSlidebarMenu)
      .on('keyup.close_slidebar', tryClosingSlidebarMenu);
  }

  // On click outside the menu close it
  document.addEventListener('click', function (event) {
    const mobileMenu = document.getElementById('mobile-menu');
    if (mobileMenu) {
      if (!mobileMenu.contains(event.target)) {
        closeSlidebarMenu();
      }
    }
  });

  function initMenuMobile() {
    slideBarOpen = $('.vtx-burger-container');

    let openedByHoverAt = 0;
    let hoverCloseTimeout = null;
    // #mobile-menu-wrapper is a full screen overlay, use the panel itself
    const hoverZone = slideBarOpen.add('#mobile-menu');

    // Open on hover (only on devices with a real pointer)
    slideBarOpen.on('mouseenter', function () {
      if (
        window.matchMedia('(hover: hover)').matches &&
        !$('body').hasClass('mobile-menu-open')
      ) {
        openedByHoverAt = Date.now();
        openSlidebarMenu();
      }
    });

    // Close when the pointer leaves both the button and the menu
    hoverZone.on('mouseenter', function () {
      clearTimeout(hoverCloseTimeout);
    });

    hoverZone.on('mouseleave', function () {
      if (!openedByHoverAt || !$('body').hasClass('mobile-menu-open')) {
        return;
      }

      clearTimeout(hoverCloseTimeout);
      hoverCloseTimeout = setTimeout(function () {
        openedByHoverAt = 0;
        closeSlidebarMenu();
      }, 300);
    });

    slideBarOpen.on('click', function (event) {
      event.stopPropagation();

      // Avoid closing the menu right after it was opened by hover
      if (Date.now() - openedByHoverAt < 600) {
        return;
      }

      if (!$('body').hasClass('mobile-menu-open')) {
        // Opened by click: keep it open when the pointer leaves
        openedByHoverAt = 0;
        openSlidebarMenu();
      } else {
        closeSlidebarMenu();
      }
    });
  }

  $(document).ready(function () {
    initMenuMobile();
  });
})(jQuery);
